import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap w-full py-3" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center text-gray-500"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" No participants in this match yet... ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("+")
const _hoisted_5 = {
  key: 1,
  class: "flex"
}
const _hoisted_6 = {
  key: 0,
  class: "flex gap-x-1"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Wrestler")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Team")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("+")

import { onMounted, ref } from 'vue';
import ParticipantEditor from './ParticipantEditor.vue';
import { v4 } from 'uuid';
import Button from '@/components/UI/Button.vue';
import { useVModels } from '@vueuse/core';
import { Match, MatchParticipant } from '@/typings/scorecard';

interface Emits {
  (e: 'type-picked', firstTime: boolean): void;
  (e: 'add'): void;
}

interface Props {
  participants: Array<MatchParticipant>;
  match: Match;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    participants: null,
    match: null
  },
  emits: ["type-picked", "add"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'type-picked', firstTime: boolean): void;
  (e: 'add'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  participants: Array<MatchParticipant>;
  match: Match;
}



const uuid = ref(v4());



const { participants: participantsValue, match } = useVModels(props);

const firstTime = ref(true);
const adding = ref(false);

function addParticipant() {
  if (match.value.Participants.length) {
    pickWrestler();
  } else if (match.value.Teams.length) {
    pickTeam();
  } else {
    adding.value = true;
  }
}

function pickWrestler() {
  match.value.Participants.push({
    SuperstarId: 0,
    ExtraText: '',
  });
  emit('type-picked', firstTime.value);
  firstTime.value = false;
  adding.value = false;
}

function pickTeam() {
  match.value.Teams.push({
    TeamId: 0,
    ExtraText: '',
  });
  emit('type-picked', firstTime.value);
  firstTime.value = false;
  adding.value = false;
}

function removeAtIndex(index: number) {
  if (match.value.Participants.length) {
    match.value.Participants.splice(index, 1);
  } else {
    match.value.Teams.splice(index, 1);
  }
  if (!match.value.Participants.length || !match.value.Teams.length) {
    firstTime.value;
  }
}

function handleAdd() {
  emit('add');
}

onMounted(() => {
  if (participantsValue.value.length > 0) {
    firstTime.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(participantsValue), (participant, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "flex items-center",
        key: `${uuid.value}_${index}`
      }, [
        _createVNode(ParticipantEditor, {
          participant: participant,
          index: index,
          onRemove: removeAtIndex,
          onPicked: handleAdd
        }, null, 8, ["participant", "index"]),
        _createElementVNode("div", {
          class: _normalizeClass([
          'px-4',
          {
            'text-gray-500': index === _unref(participantsValue).length - 1,
          },
        ])
        }, " vs ", 2)
      ]))
    }), 128)),
    (_unref(participantsValue).length === 0 && !adding.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(Button, {
            class: "ml-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (addParticipant()))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (adding.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(Button, { onClick: pickWrestler }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createVNode(Button, { onClick: pickTeam }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(Button, {
            class: "ml-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (addParticipant()))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]))
  ]))
}
}

})